import React from 'react';
import { UltraSimpleMessageList } from './UltraSimpleMessageList';
import { Message } from '@/types/chat';

interface Partner {
  id: string;
  username?: string;
  avatar?: string;
  gender?: string;
  role?: string;
  relationship_type?: string;
  bio_topics?: string[];
}

interface MessageListWrapperProps {
  messages: Message[];
  currentUserId: string;
  partner: Partner;
  hasOlderMessages?: boolean;
  loadingOlderMessages?: boolean;
  onReply?: (messageId: string, content: string, senderId: string) => void;
  onDelete?: (messageId: string) => void;
  onLoadOlderMessages?: () => void;
  onSelectIcebreaker?: (text: string) => void;
}

export const MessageListWrapper: React.FC<MessageListWrapperProps> = (props) => {
  return (
    <div className="h-full">
      <UltraSimpleMessageList {...props} />
    </div>
  );
};
